import React, { PureComponent } from 'react'
import { Modal, Button, Header, Icon } from 'semantic-ui-react'
import PropTypes from 'prop-types'

export default class ConfirmModal extends PureComponent {

  static defaultProps = {
    icon: 'delete',
    title: 'Delete',
    explainText: 'Are you sure?',
    confirmText: 'Yes',
    cancelText: 'No',
    trigger: 'button',
    onConfirm: () => {},
    onCancel: () => {}
  }

  static propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    explainText: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    trigger: PropTypes.object,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      showModal: false
    }
  }

  onActionStart = (e) => {
    e.stopPropagation()
    this.setState({ showModal: true })
  }

  onConfirm = () => {
    this.setState({ showModal: false })
    this.props.onConfirm()
  }

  onCancel = () => {
    this.setState({ showModal: false })
    this.props.onCancel()
  }

  render () {
    const trigger = React.cloneElement(this.props.trigger, {
      onClick: this.onActionStart
    })
    return (
      <Modal trigger={trigger} basic size="small" open={this.state.showModal}>
        <Header icon={this.props.icon} content={this.props.title} />
        <Modal.Content>
          <p>{this.props.explainText}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color='red' inverted onClick={this.onCancel}>
            <Icon name='remove' />
            {this.props.cancelText}
          </Button>
          <Button color='green' inverted onClick={this.onConfirm}>
            <Icon name='checkmark' />
            {this.props.confirmText}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/ConfirmModal.js